import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';

export const Route = createFileRoute('/_authenticated/dashboard/locations')({
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    if (session.user.role !== 'org_admin') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
  staticData: {
    breadcrumb: ['Manage', 'Locations'],
  },
});
